<div class="text-center">
    <button  class="btn btn-primary w-100 mt-5 btn-lg" (click)="addStudentRegistrationPopup()" > <i class='fa fa-user-plus'></i> Click Here to Register Add Student</button>
    <a [routerLink]="['/guardian/show',guardian.server_user_id,1]"  class="btn btn-outline-primary w-100 btn-lg mt-2 mb-2">  <i class='fa fa-dot-circle-o '></i> Click Here to go to Start Page</a>
</div>
<div id="tourCouroselIndicator" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
        <li data-target="#tourCouroselIndicator" data-slide-to="0" class="active"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="1"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="2"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="3" class="active"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="4"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="5"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="6"></li>
        <li data-target="#tourCouroselIndicator" data-slide-to="7"></li>
      </ol>
      <div class="carousel-inner">
      <div class="carousel-item active">
          <img class="d-block w-100" src="/assets/images/onboard/step0a.png" alt="Slide Start Here">
           <div class="carousel-caption d-none d-md-block">
            <h5>Click To Add Student</h5>
            <p>...</p>
      </div>
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step1a.png" alt="Slide Add Student">
           <div class="carousel-caption d-none d-md-block">
            <h5> Add Student to go to student form</h5>
            <p>...</p>
        </div>
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step2a.png" alt="Slide Add Stuent Form">
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step3a.png" alt="Slide Enrol Student Form">
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step4a.png" alt="Third slide">
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step5a.png" alt="Third slide">
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step6a.png" alt="Third slide">
      </div>
      <div class="carousel-item">
          <img class="d-block w-100" src="/assets/images/onboard/step7a.png" alt="Third slide">
      </div>
        <a class="carousel-control-prev" href="#tourCouroselIndicator" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#tourCouroselIndicator" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
      </div>
    </div>
    <div class="text-center">
        <button  class="btn btn-primary w-100 mt-5 btn-lg" (click)="addStudentRegistrationPopup()" > <i class='fa fa-user-plus'></i> Click Here to Register Add Student</button>
        <a [routerLink]="['/guardian/show',guardian.server_user_id,1]"  class="btn btn-outline-primary w-100 btn-lg mt-2 mb-2">  <i class='fa fa-dot-circle-o '></i> Click Here to go to Start Page</a>
    </div>
    <app-register-student [guardian]="guardian"></app-register-student>